import styles from "./Footer.module.scss";
// import logo from "../../assets/images/site-logo/Logo.png";
import logo from "../../assets/images/layouts/180x70.png";
// import { navigation } from "../../constants/navigation";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { Link } from "react-router-dom";
import { useLangPath } from "../../hooks/useLangPath";

const Footer = () => {
  const { data } = useSelector((state: RootState) => state.translationData);
  const lp = useLangPath();

  const navigation = [
    { name: data?.header,                    path: lp("home") },
    { name: data?.tariffs,                   path: lp("tariffs") },
    { name: data?.updates,                   path: lp("innovations") },
    { name: data?.stores,                    path: lp("stores") },
    { name: data?.about_us,                  path: lp("about") },
    { name: data?.services_title || "Xidmətlər",   path: lp("services") },
    { name: data?.contacts,                  path: lp("contact") },
  ];

  const transitions = [
    { name: data?.prohibited_items,  path: lp("forbidden") },
    { name: data?.user_agreement,    path: "https://colibri.az/uploads/static/new_terms_az.pdf" },
    { name: data?.faq,               path: lp("questions") },
    { name: data?.dangerous_goods,   path: lp("dangerousPackages") },
    { name: data?.privacy_policy,    path: lp("privacyPolicy") },
  ];

  return (
    <div id={styles.footer}>
      <div className="container">
        <div className={styles.footer}>
          <div className={styles.footer_top}>
            <div className={styles.about}>
              <div className={styles.logo}>
                <Link to={lp("home")}>
                  <img src={logo} alt="" />
                </Link>
              </div>
            </div>
            <ul className={styles.nav_list}>
              <h4 className={styles.links_title}>{data?.header}</h4>
              {navigation.slice(1).map((nav, idx) => (
                <li key={idx} className={styles.list}>
                  <Link className={styles.navlink} to={nav.path}>
                    {nav.name}
                  </Link>
                </li>
              ))}
            </ul>
            <ul className={styles.nav_list}>
              <h4 className={styles.links_title}>{data?.links}</h4>
              {transitions.map((nav, idx) => {
                const isUserAgreement =
                  nav.path ===
                  "https://colibri.az/uploads/static/new_terms_az.pdf";

                return (
                  <li key={idx} className={styles.list}>
                    <Link
                      className={styles.navlink}
                      to={nav.path}
                      target={isUserAgreement ? "_blank" : undefined}
                      rel={isUserAgreement ? "noopener noreferrer" : undefined}
                    >
                      {nav.name}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className={styles.footer_bottom}>
            <div className={styles.footer_end}>
              <p className={styles.site_title}>{data?.colibri}©2025</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;